import {Tab as MuiTab, Tabs as MuiTabs, styled} from '@mui/material';

/**
 * A tab strip (spec section 3, "Tabs"): MUI Tabs on the theme — 36px, 2px
 * ink indicator, from the MuiTabs override — over a hairline. Name the
 * strip (`aria-label`) when the page has more than one.
 */
export const Tabs = styled(MuiTabs)(({theme}) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
}));

/**
 * One tab: label colour and weight come from the MuiTab override (selected
 * text.primary, rest text.secondary, 500); a rounded hover wash here.
 */
export const Tab = styled(MuiTab)(({theme}) => ({
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
